export default __webpack_public_path__ + "static/media/previous_expo_2019 (9).77a702c7.jpg";